import { Head } from "@/components/base/Head";
import React from "react";
import { SectionTitle } from "@/components/base/ui/SectionTitle";
import { Breadcrumb } from "@/components/base/Breadcrumb";

const PolicyPage = () => {
  const META_TITLE = "プライバシーポリシー";
  const breadcrumbs = [
    {
      title: META_TITLE,
    },
  ];
  return (
    <>
      <Head title={META_TITLE} canonicalPath={`/policy`} />
      <main className={"md:bg-gray-50 pb-20"}>
        <div className={"mb-10 max-w-[1440px] m-auto px-4 py-2"}>
          <Breadcrumb breadcrumbs={breadcrumbs} />
        </div>
        <div className={"max-w-[960px] bg-white m-auto p-5 md:p-10 rounded"}>
          <div className={"mb-10"}>
            <div className={"mb-4"}>
              <SectionTitle title={"プライバシーポリシー"} isBorder={false} />
            </div>
            <p className={""}>
              株式会社戦略デザインラボ（以下、「当社」）は、当社が運営するオンラインラーニングサービス『戦略ラボ』（以下、「本サービス」）における、
              利用者の皆様（以下、「会員」）についての個人情報の取扱いについて、以下のとおりプライバシーポリシー（以下、「本ポリシー」）を定めます。
            </p>
          </div>
          <div className={"mb-8"}>
            <h3 className={"font-bold mb-2"}>第1条 情報の取得</h3>
            <p className={"mb-6"}>
              1項
              本ポリシーにおいて、個人情報とは、個人情報保護法第2条第1項により定義された個人情報を意味するものとします。
              <br />
              2項 当社が会員から取得する個人情報は以下のものとします。
            </p>
            <ol className={"list-decimal pl-6"}>
              <li>氏名</li>
              <li>生年月日</li>
              <li>所属する企業の名称（個人の会員の場合は除く）</li>
              <li>メールアドレス</li>
              <li>会員の本サービスにおける受講履歴</li>
              <li>本サービスおいて会員が投稿したメッセージ</li>
            </ol>
          </div>
          <div className={"mb-8"}>
            <h3 className={"font-bold mb-2"}>第2条 利用目的</h3>
            <p className={"mb-6"}>
              1項 当社は、以下の目的で会員の個人情報を利用することがあります。
            </p>
            <ol className={"list-decimal pl-6 mb-6"}>
              <li>本サービスの提供および運営のため</li>
              <li>本サービスその他の当社が運営するサービスの広報活動のため</li>
              <li>
                会員へのお知らせや本サービスその他の当社が運営するサービスに関するご案内（本サービスその他の当社が運営するサービスに係る利用規約の変更、本サービスその他の当社が運営するサービスの内容の変更等を含む）のため
              </li>
              <li>会員への本人確認、本人認証のため</li>
              <li>お問い合わせへのご対応のため</li>
              <li>利用動向の調査、統計、分析のため</li>
              <li>新サービス、新機能の開発のため</li>
              <li>システムの維持・改善、不具合対応のため</li>
              <li>その他上記利用目的に付随する目的のため</li>
            </ol>
            <p>
              2項
              当社は、前項の利用目的を、関連性を有すると合理的に認められる範囲内において変更することがあり、変更した場合には会員に通知又は公表します。
            </p>
          </div>
          <div className={"mb-8"}>
            <h3 className={"font-bold mb-2"}>第3条 個人情報利用の制限</h3>
            <p className={"mb-6"}>
              当社は、個人情報保護法その他の法令により許容される場合を除き、会員の同意を得ず、利用目的の達成に必要な範囲を超えて個人情報を取り扱いません。但し、次の場合はこの限りではありません。
            </p>
            <ol className={"list-decimal pl-6"}>
              <li>法令に基づく場合</li>
              <li>
                人の生命、身体又は財産の保護のために必要がある場合であって、会員の同意を得ることが困難であるとき
              </li>
              <li>
                公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、会員の同意を得ることが困難であるとき
              </li>
              <li>
                国の機関もしくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、会員の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき
              </li>
            </ol>
          </div>
          <div className={"mb-8"}>
            <h3 className={"font-bold mb-2"}>第4条 個人情報の適正な取得</h3>
            <p>
              当社は、適正に個人情報を取得し、偽りその他不正の手段により取得しません。
            </p>
          </div>
          <div className={"mb-8"}>
            <h3 className={"font-bold mb-2"}>第5条 個人情報の安全管理</h3>
            <p>
              当社は、個人情報の紛失、破壊、改ざん及び漏洩などのリスクに対して、個人情報の安全管理が図られるよう、当社の従業員に対し、必要かつ適切な監督を行います。また、当社は、個人情報の取扱いの全部又は一部を委託する場合は、委託先において個人情報の安全管理が図られるよう、必要かつ適切な監督を行います。但し、本サービスを利用するにあたって取得して頂くアカウント、パスワードの管理は、利用規約に従って、会員の自己責任で管理して頂くものとします。
            </p>
          </div>
          <div className={"mb-8"}>
            <h3 className={"font-bold mb-2"}>第6条 第三者への提供</h3>
            <p className={"mb-6"}>
              当社は、個人情報保護法その他の法令に基づき開示が認められる場合を除くほか、あらかじめ会員の同意を得ないで、個人情報を第三者に提供しません。但し、次に掲げる場合は上記に定める第三者への提供には該当しません。
            </p>
            <ol className={"list-decimal pl-6"}>
              <li>
                当社が利用目的の達成に必要な範囲内において個人情報の取扱いの全部又は一部を委託する場合
              </li>
              <li>
                合併その他の事由による事業の承継に伴って個人情報が提供される場合
              </li>
              <li>個人情報保護法の定めに基づき共同利用する場合</li>
              <li>その他、個人情報保護法その他の法令で認められる場合</li>
            </ol>
          </div>
          <div className={"mb-8"}>
            <h3 className={"font-bold mb-2"}>第7条 個人情報の開示</h3>
            <p>
              当社は、会員から、個人情報保護法の定めに基づき個人情報の開示を求められたときは、会員ご本人からのご請求であることを確認の上で、会員に対し、遅滞なく開示を行います（当該個人情報が存在しないときにはその旨を通知いたします。）。但し、個人情報保護法その他の法令により、当社が開示の義務を負わない場合は、この限りではありません。なお、個人情報の開示につきましては、手数料（1件あたり1000円）を頂戴しておりますので、あらかじめ御了承ください。
            </p>
          </div>
          <div className={"mb-8"}>
            <h3 className={"font-bold mb-2"}>第8条 個人情報の利用停止等</h3>
            <p>
              当社は、会員から、会員の個人情報が、あらかじめ公表された利用目的の範囲を超えて取り扱われているという理由又は偽りその他不正の手段により取得されたものであるという理由により、個人情報保護法の定めに基づきその利用の停止又は消去（以下、「利用停止等」）を求められた場合において、そのご請求に理由があることが判明した場合には、会員ご本人からのご請求であることを確認の上で、遅滞なく個人情報の利用停止等を行い、その旨を会員に通知します。但し、個人情報保護法その他の法令により、当社が利用停止等の義務を負わない場合は、この限りではありません。
            </p>
          </div>
          <div className={"mb-8"}>
            <h3 className={"font-bold mb-2"}>
              第9条 Cookie（クッキー）その他の技術の利用
            </h3>
            <p>
              本サービスは、Cookie及びこれに類する技術を利用することがあります。これらの技術は、当社による本サービスの利用状況等の把握に役立ち、サービス向上に資するものです。Cookieを無効化されたい会員は、ウェブブラウザの設定を変更することによりCookieを無効化することができます。但し、Cookieを無効化すると、当社のサービスの一部の機能をご利用いただけなくなる場合があります。なお、かかる技術の使用により、会員が入力していない個人情報を取得することはありません。
            </p>
          </div>
          <div className={"mb-8"}>
            <h3 className={"font-bold mb-2"}>第10条 セキュリティに関して</h3>
            <p>
              会員の情報は会員のプライバシー保護及び、セキュリティの為パスワードで保護されています。当社は必要がある場合、データ転送を保護する為に業界標準のSSL暗号を使用します。
            </p>
          </div>
          <div className={"mb-8"}>
            <h3 className={"font-bold mb-2"}>
              第11条 本ポリシーの改正について
            </h3>
            <p>
              当社は個人情報の取扱いに関する運用状況を適宜見直し、継続的な改善に努めるものとし、本ポリシーを一部改定する場合がございます。重要な変更がある場合には、サイト上でお知らせします。
            </p>
          </div>
          <div className={"mb-8"}>
            <h3 className={"font-bold mb-2"}>
              第12条 プライバシーに関する問合せ
            </h3>
            <p>
              プライバシーに関するご意見・お問合せ等がございましたら、support@s-d-lab.jp
              までメールにてお問い合わせください。
            </p>
          </div>
          <p className={"mt-12"}>2021年12月27日作成</p>
        </div>
      </main>
    </>
  );
};

export async function getStaticProps() {
  return {
    props: {},
  };
}
export default PolicyPage;
